import React from 'react';
import { Heart, MapPin, Calendar, Info } from 'lucide-react';
import { WeddingInvitation } from '../types/invitation';
import CollaborationRoleBadge from './CollaborationRoleBadge';

interface InvitationContextBannerProps {
  invitation: WeddingInvitation | null;
  className?: string;
}

/**
 * 邀請函上下文橫幅組件
 * 顯示當前編輯的邀請函詳情和使用者角色
 */
const InvitationContextBanner: React.FC<InvitationContextBannerProps> = ({
  invitation,
  className = ''
}) => {
  if (!invitation) {
    return (
      <div className={`bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6 ${className}`}>
        <div className="flex items-center justify-center text-gray-500">
          <Info className="w-5 h-5 mr-2" />
          <span>未選擇邀請函</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-gradient-to-r from-wedding-pink/10 to-wedding-purple/10 border-2 border-wedding-pink/30 rounded-lg p-4 mb-6 ${className}`}>
      <div className="flex items-center justify-between">
        {/* 左側：邀請函資訊 */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-3 mb-2">
            <Heart className="w-5 h-5 text-wedding-pink flex-shrink-0" />
            <h3 className="text-lg font-semibold text-wedding-text-title truncate">
              {invitation.brideName} & {invitation.groomName} 的婚禮
            </h3>
            {invitation.role && (
              <CollaborationRoleBadge role={invitation.role} size="small" />
            )}
          </div>
          
          <div className="flex items-center space-x-4 text-sm text-wedding-text-body">
            <div className="flex items-center space-x-1">
              <Calendar className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{invitation.weddingDate}</span>
            </div>
            <div className="flex items-center space-x-1">
              <MapPin className="w-4 h-4 flex-shrink-0" />
              <span className="truncate">{invitation.venue}</span>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default InvitationContextBanner;